import React from "react";
import Constant from "../../../../common/constants/define";
import { formatDateEN, formatDateENGB } from "../../../../common/utils/date";
import { getMyPerson } from "../../../../common/utils/family";

class MyStuffSchedule extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ofces: this.props.ofces, node: this.props.node };
  }

  getScheduleItem_v(fce) {
    //alert(fce.Start);
    /*if (
      fce.HmId != this.state.node.Group?.GId &&
      fce.GuId != this.state.node.Group?.GId &&
      this.state.node.Act.AType != Constant.TP_CLASS &&
      this.state.node.Act.AType != Constant.TP_EVENT
    ) {
      alert(3);
      return;
    }*/
//console.log(JSON.stringify(this.state.ofces, null, 2));
    let d = formatDateENGB(fce.Start);
    let start = formatDateEN(fce.Start);

    let p = getMyPerson(this.props.mypid, this.props.family);
    let name = p.FName + " " + p.LName;


    return (
      <div className="row purchases-item mx-1">
        <div className="col-12">
          <div className="row">
            <div className="col-3 purchased-class-container pl-4">
              <p className="cart-item-info">
                <span id="class-type">{name} </span>
              </p>
            </div>
            <div className="col-4 purchased-class-container schelisttime">
              <p className="cart-item-info">
                <span id="class-type">{d}<br></br>{start} </span>
              </p>
            </div>
            <div className="col-5 purchased-class-container">
              <p className="cart-item-info actschname">
                <span id="class-type">
                  {this.props.actname}
                  <span dangerouslySetInnerHTML={{ __html: fce.Name }} />{" "}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  getScheduleList_v() {
    const items = [];
    //let nowdate = new Date().toJSON().slice(0,10).split('-').reverse().join('/');
    //alert(this.state.ofces.length);
    for (let i = 0; i < this.state.ofces.length; i++) {
      //let fce = this.state.ofces[i];
      //let fcedate = new Date(fce.Start).toJSON().slice(0,10).split('-').reverse().join('/');
      //alert(fcedate);
      //if (fcedate >= nowdate) {
        //alert(this.getScheduleItem_v(this.state.ofces[i]));
        items.push(this.getScheduleItem_v(this.state.ofces[i]));
      //}
    }

    return (
      <>
        <div className="d-flex justify-content-between align-items-center schedule-header rounded">
          <span className="schedule-title-date d-flex justify-content-center">
            Name
          </span>
          <span className="schedule-title-time d-flex justify-content-center">
            Time
          </span>
          <span className="schedule-title-detail d-flex justify-content-center pl-4">
            Detail
          </span>
        </div>
        {items}
      </>
    );
  }

  render() {
    return <div>{this.getScheduleList_v()}</div>;
  }
}

export default MyStuffSchedule;